export default "__VITE_ASSET__4cd13e6d__"